import { graphql, useStaticQuery } from 'gatsby'

import { parseStoryblokContent } from './parse-storyblok-content'

export function useWatchCourseForm() {
  const { formData } = useStaticQuery(graphql`
    query {
      formData: storyblokEntry(
        field_component: { eq: "watchCourseForm" }
      ) {
        id
        name
        uuid
        field_component
        content
      }
    }
  `)

  return parseStoryblokContent(formData)
}
